//import { GameResult, PairResult, RoundResult } from './round-result.ts';

import {RoundResult} from './round-result.js';
import {fromRawData} from './score-board-data.js';
import {BeadRoad} from './roads/bead-road.js';
import {BigRoad} from'./roads/big-road.js';
import {BigEyeRoad} from './roads/big-eye-road.js';
import {SmallRoad} from './roads/small-road.js';
import {CockroachRoad} from './roads/cockroach-road.js';




//GameResult
// 0 : Tie
// 1 : BankerWin
// 2 : PlayerWin

//PairResult
// 0 : NoPair
// 1 : BankerPair
// 2 : PlayerPair
// 3 : AllPair

class ScoreBoard {
    constructor(roundResults) {
        this.roundResults = roundResults.map(result => RoundResult.from(result));
    }
    /**
     * Banker Count
     */
    get bankerCount() {
        return this.roundResults.filter(round => round.gameResult === 1/*GameResult.BankerWin*/).length;
    }
    /**
     * Player Count
     */
    get playerCount() {
        return this.roundResults.filter(round => round.gameResult === 2/*GameResult.PlayerWin*/).length;
    }
    /**
     * Tie Count
     */
    get tieCount() {
        return this.roundResults.filter(round => round.gameResult === 0/*GameResult.Tie*/).length;
    }
    /**
     * Natural Count
     */
    get naturalCount() {
        return this.roundResults.filter(round => round.result === 8 || round.result === 9).length;
    }
    /**
     * Banker Pair Count
     */
    get bankerPairCount() {
        //return this.roundResults.filter(round => round.pairResult === PairResult.BankerPair ||
        //    round.pairResult === PairResult.AllPair).length;
        return this.roundResults.filter(round => round.pairResult === 1 ||
            round.pairResult === 3).length;
    }
    /**
     * Player Pair Count
     */
    get playerPairCount() {
        return this.roundResults.filter(round => round.pairResult === 2 ||
            round.pairResult === 3).length;
    }
    static fromRawData(results) {
        const res = results.slice();
        res.reverse();
        return new ScoreBoard(fromRawData(res));
    }
    
    getBeadRoad(row = 6, column = 14) {
        return new BeadRoad(row, column, this.roundResults);
    }
    getBigRoad(row = 6, column = 42) {
        return new BigRoad(row, column, this.roundResults);
    }
    getBigEyeRoad(row = 6, column = 84) {
        return new BigEyeRoad(row, column, this.roundResults);
    }
    getSmallRoad(row = 6, column = 42) {
        return new SmallRoad(row, column, this.roundResults);
    }
    getCockroachRoad(row = 6, column = 42) {
        return new CockroachRoad(row, column, this.roundResults);
    }
}

export{ScoreBoard};
